export default __webpack_public_path__ + "f27321aadd52df5446f7878906c7ddfa.png";